import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart, Loader2 } from "lucide-react";
import { api, setToken } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      setToken(data.token);
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(
        (Array.isArray(detail) ? detail[0]?.msg : detail) ||
          "Login failed. Check your email and password.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream px-4 font-sans text-ink antialiased">
      <div className="w-full max-w-md rounded-[28px] border border-line bg-white p-8 shadow-xl shadow-rose/5 md:p-10">
        <div className="mb-8 text-center">
          <div className="flex items-center justify-center gap-2">
            <Heart size={20} className="fill-rose text-rose" />
            <span className="font-serif text-3xl font-semibold tracking-tight">
              Gifting Loves
            </span>
          </div>
          <p className="mt-2 text-xs font-semibold uppercase tracking-[0.25em] text-rose">
            Admin Dashboard
          </p>
        </div>

        <form data-testid="admin-login-form" onSubmit={submit} className="flex flex-col gap-6">
          <div>
            <label htmlFor="admin-email" className="mb-2 block text-[11px] font-semibold uppercase tracking-[0.2em] text-[#5C5C5C]">
              Email / Username
            </label>
            <input
              id="admin-email"
              data-testid="admin-email-input"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
              className="w-full rounded-xl border border-line bg-cream/50 px-4 py-3.5 text-sm text-ink outline-none transition-colors focus:border-rose"
              placeholder="admin@giftingloves.com"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-2 block text-[11px] font-semibold uppercase tracking-[0.2em] text-[#5C5C5C]">
              Password
            </label>
            <input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              className="w-full rounded-xl border border-line bg-cream/50 px-4 py-3.5 text-sm text-ink outline-none transition-colors focus:border-rose"
              placeholder="Your password"
            />
          </div>

          {error && (
            <p data-testid="admin-login-error" className="rounded-xl bg-red-50 px-4 py-3 text-xs font-medium text-red-600">
              {error}
            </p>
          )}

          <button
            data-testid="admin-login-button"
            type="submit"
            disabled={loading}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-ink px-8 py-4 text-sm font-medium text-cream transition-colors duration-300 hover:bg-rose hover:text-white disabled:opacity-60"
          >
            {loading ? (
              <>
                <Loader2 size={16} className="animate-spin" /> Signing in…
              </>
            ) : (
              "Sign In"
            )}
          </button>
        </form>

        <p className="mt-8 text-center text-xs text-[#5C5C5C]">
          <a href="/" className="transition-colors hover:text-rose">
            ← Back to website
          </a>
        </p>
      </div>
    </div>
  );
}
